<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @cancel="handleCancel"
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': true} }"
    :okDisabled=true
    :cancelText="language['common.closeButton']">
    <apptype-application-list-form ref="realForm" :appTypeName="this.appTypeName" :appTypeId="this.appTypeId" :entranceName="this.entranceName"></apptype-application-list-form>
    <template slot="footer">
      <a-button @click="handleCancel">{{language['common.closeButton']}}</a-button>
    </template>
  </j-modal>
</template>

<script>

  import ApptypeApplicationListForm from './ApptypeApplicationListForm'
  export default {
    name: 'ApptypeApplicationListModal',
    components: {
      ApptypeApplicationListForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: true,
        appTypeId: '',
        appTypeName: '',
        entranceName: '',
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      listdetail (appTypeId,appTypeName,entranceName) {
        this.visible = true;
        this.appTypeId = appTypeId;
        this.appTypeName = appTypeName;
        this.entranceName = entranceName;
        this.disableSubmit = true;
      },
    }
  }
</script>